__turbopack_context__.v({
  "button": "_4X8-va_button",
  "button--icon": "_4X8-va_button--icon",
  "button--icon--selected": "_4X8-va_button--icon--selected",
  "button--inverted": "_4X8-va_button--inverted",
  "button--plain": "_4X8-va_button--plain",
  "button--secondary": "_4X8-va_button--secondary",
  "button--small": "_4X8-va_button--small",
  "button--tertiary": "_4X8-va_button--tertiary",
  "button__prefix": "_4X8-va_button__prefix",
  "button__suffix": "_4X8-va_button__suffix",
});
